export const infracaoFormStructure = [
  [
    {
      name: 'id',
      label: 'Id',
      component: 'FormField',
      type: 'number',
      colProps: { md: 2 },
      readOnly: true,
      disabled: true
    },
    {
      name: 'descricao',
      label: 'Descricao',
      component: 'FormField',
      type: 'text',
      colProps: { md: 7 },
      maxLength: 500
    },
    {
      name: 'porcentagemDesconto',
      label: 'Porcentagem Desconto',
      component: 'FormField',
      type: 'number',
      colProps: { md: 3 }
    }
  ],
  [
    {
      name: 'descricaoGrupo',
      label: 'Descricao Grupo',
      component: 'FormField',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 3
    },
    {
      name: 'descricaoPlanoAcao',
      label: 'Descricao Plano Acao',
      component: 'FormField',
      type: 'textarea',
      colProps: { md: 6 },
      rows: 3
    }
  ]
];

export const infracaoFormSections = () => [
  { title: 'Infracao', rows: [0, 1] }
];

export const validateInfracaoForm = () => ({});

export const emptyInfracaoForm = {
  id: '',
  descricao: '',
  descricaoGrupo: '',
  descricaoPlanoAcao: '',
  porcentagemDesconto: ''
};
